import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import moment from 'moment';
import {
  HistoryPanelTitle,
  DownloadCSVWrapper,
  TopPanelWrapper,
  FilterWrapper
} from './styled';
import DownloadCSV from '../../../components/DownloadCSV';
import WidgetActionComponent from '../../../components/WidgetActionComponent';
import { UNIFIED_ALERTS_SOURCE_IDS, DOWNLOAD_LIMIT } from './constants';
import csvColumnsIndex from './csvColumnsIndex';
import { NetworkLayer } from '../../../services/common';
import FilterOption from './FilterOption';

const AlertHistoryTopPanel = ({
  dateRange,
  customerId,
  widgetTitle,
  onChangeWidgetAction,
  onFilterChangeAction,
  optedFilterOption
}) => {
  const [downloadList, setDownloadList] = useState([]);

  const onAlertHistDownload = async () => {
    const commonService = new NetworkLayer();
    setDownloadList([]);
    const { startDate, endDate } = dateRange;
    const alertHistory = await commonService.amlsCommonUnifiedAlertsAPI({
      customerId,
      sourceIds: optedFilterOption.sourceIds.join(','),
      from: startDate.toISOString(),
      to: endDate.toISOString(),
      limit: DOWNLOAD_LIMIT,
      offset: 0,
      q: 'eyJzb3J0Ijp7fSwiZmlsdGVyIjpbXX0K' //TODO: send valided q value
    });
    setDownloadList(alertHistory?.payload || []);
  };

  const getDownloadFileName = () => {
    const dateObj = new Date();
    const timestamp = dateObj.getTime();
    return `Alert_Details_${customerId}--${dateRange.startDate.format(
      'DDMMYYYY'
    )}-to-${dateRange.endDate.format('DDMMYYYY')}__${timestamp}.csv`;
  };

  // Can not select days after current date
  const disabledDate = (current) => current && current > moment().endOf('day');

  const handleFilterChangeAction = (sourceIds) => {
    const finalSourceIds = isEmpty(sourceIds)
      ? UNIFIED_ALERTS_SOURCE_IDS
      : sourceIds;
    onFilterChangeAction?.(finalSourceIds);
  };

  return (
    <>
      <TopPanelWrapper>
        <HistoryPanelTitle>{widgetTitle}</HistoryPanelTitle>
        {/* <DownloadCSVWrapper>
          <DownloadCSV
            csvData={downloadList}
            csvHeaders={csvColumnsIndex}
            fileName={getDownloadFileName()}
            onDownloadClick={onAlertHistDownload}
          />
        </DownloadCSVWrapper> */}
      </TopPanelWrapper>
      <FilterWrapper>
        <WidgetActionComponent
          size="small"
          hasDurationPicker
          hasDatePicker
          onChangeActions={onChangeWidgetAction}
          disabledDate={disabledDate}
        />
        <FilterOption
          onChangeAction={handleFilterChangeAction}
          optedFilterOption={optedFilterOption}
        />
      </FilterWrapper>
    </>
  );
};

AlertHistoryTopPanel.propTypes = {
  dateRange: PropTypes.object,
  customerId: PropTypes.string,
  widgetTitle: PropTypes.string,
  onChangeWidgetAction: PropTypes.func,
  onFilterChangeAction: PropTypes.func,
  optedFilterOption: PropTypes.object
};

export default AlertHistoryTopPanel;
